angular.module('bmsApp.user')
	.factory('AuthService', function ($http, $log, $window, $q, Session, $rootScope, $cookieStore, $location, $state, $stateParams, CRUDSvc) {
		var user = null;

		function login(credentials) {
			return CRUDSvc.post('api/login', credentials).then(function (response) {
				user = response.data.user;
				// user.app_settings = response.data.app_settings;
				// user.licenses = response.data.licenses;
				user.franchise = response.data.franchise;
				$rootScope.franchise = response.data.franchise;
				angular.extend($rootScope, {
					app: {
						version: response.data.version
					}
				});

				$rootScope.$broadcast("loggedIn");
				return response;
			});
		}

		function getSettingsAndLicences(instance) {
			return CRUDSvc.post('api/get-settings-and-licences').then(function (response) {
				user.app_settings = response.data.app_settings;
				user.licenses = response.data.licenses;
				return response;
			});
		}

		function logout() {
			if (angular.isObject(user)) {
				return CRUDSvc.get('api/logout')
					.then(function (response) {
						user = null;
					});
			}
		}

		function redirect() {
			// for now just redirect to site index
			// TODO: Logic to determine where user should start
			var redirect = $stateParams.redirect;

			if ($state.is('empty')) {
				$state.go('root');
			}
			else if (angular.isString(redirect) && redirect.length) {
				$window.location.href = redirect;
			}
			else {
				if (user.role_list === 'training') {
					$state.go('main.dashboard.training');
				}
				else {
					// for now assuming that everyone can access sites
					$state.go('main.dashboard.overview');
				}
			}
		}

		function isAuthenticated() {
			return angular.isObject(user);
		}

		function getUserObject() {
			return user;
		}

		function getRawUser() {
			return user;
		}

		function getUser() {
			var deferred = $q.defer();

			if (user) {
				deferred.resolve(user);
			}
			else {
				login().finally(function () {
					deferred.resolve(user);
				});
			}

			return deferred.promise;
		}


		
		function hasPermission(permission) {
			var retVal = false;
			if (angular.isObject(user) && angular.isDefined(user.permission_list)) {
				var permissions = user.permission_list;
				angular.forEach(permissions, function (perm) {
					if (perm.toLowerCase() == permission.toLowerCase()) {
						retVal = true;
					}
				});
			}
			return retVal;
		}

		


		return {
			login: login,
			logout: logout,
			redirect: redirect,
			isAuthenticated: isAuthenticated,
			getUser: getUser,
			hasPermission: hasPermission,
			getUserObject: getUserObject,
			getRawUser: getRawUser
		};
	});
